<template>
  <NodeEvents v-if="node && entityType === 'eventinstance'" :event="node" />
  <NodePage v-else-if="node" v-bind="node" />
</template>

<script lang="ts" setup>
import type {
  NodePageFragment,
  EventinstanceDefaultFragment,
} from '#graphql-operations'

defineOptions({
  name: 'PageSlug',
})

definePageMeta({
  name: 'drupal-route',
  path: '/:slug(.*)*',
  drupalRoute: true,
  languageMapping: {
    de: '/:slug(.*)*',
    fr: '/fr/:slug(.*)*',
    en: '/en/:slug(.*)*',
  },
})

const nuxtRoute = useRoute()

// Get the data.
const { data: query } = await useAsyncGraphqlQuery(
  'route',
  {
    path: nuxtRoute.path,
  },
  {
    transform: (v) => v.data,
    graphqlCaching: {
      client: true,
    },
  },
)

// Handles redirects and metatags.
const { entity: node } = (await useDrupalRoute<
  NodePageFragment | EventinstanceDefaultFragment
>(query.value)) as { entity: any }

const entityType = computed(
  // @ts-ignore
  () => query.value?.route?.drupalRouteEntity?.entityTypeId,
)

useRouteEntity(node)

setLanguageLinksFromRoute(query.value)
await renderPageDependencies()
</script>
